var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNumber2Gray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_710_988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30781 72V61.5L35.3078 36C37.4411 34.0667 39.0078 32.3333 40.0078 30.8C41.0078 29.2667 41.6745 27.8667 42.0078 26.6C42.4078 25.3333 42.6078 24.1667 42.6078 23.1C42.6078 20.3 41.6411 18.1667 39.7078 16.7C37.8411 15.1667 35.0745 14.4 31.4078 14.4C28.4745 14.4 25.7411 14.9667 23.2078 16.1C20.7411 17.2333 18.6411 19 16.9078 21.4L5.10781 13.8C7.77448 9.8 11.5078 6.63333 16.3078 4.3C21.1078 1.96666 26.6411 0.799999 32.9078 0.799999C38.1078 0.799999 42.6411 1.66666 46.5078 3.4C50.4411 5.06666 53.4745 7.43333 55.6078 10.5C57.8078 13.5667 58.9078 17.2333 58.9078 21.5C58.9078 23.7667 58.6078 26.0333 58.0078 28.3C57.4745 30.5 56.3411 32.8333 54.6078 35.3C52.9411 37.7667 50.4745 40.5333 47.2078 43.6L24.8078 64.7L21.7078 58.8H61.2078V72H8.30781Z",
    fill: "url(#paint0_linear_710_988)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_710_988",
    x: 0.107422,
    y: 0.799805,
    width: 66.0996,
    height: 81.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_710_988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_710_988",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_988",
    x1: 34.5,
    y1: 2,
    x2: 34.5,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707070",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F1F",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber2Gray);
export default __webpack_public_path__ + "static/media/number_2_gray.bf19dc6badd824c4ad8e441f54f37a52.svg";
export { ForwardRef as ReactComponent };